<script setup lang="ts">
import { SitemapProps } from "./Index.props"

const props = defineProps<SitemapProps>()
</script>

<template>
  <div>
    <div class="grid-standard">
      <div class="col-span-full md:col-span-10 md:col-start-2">
        <h1 class="elephant-bold md:mammoth-bold mb-2 mt-4 md:my-6">
          {{ props.title ?? $t("sitemap.title") }}
        </h1>
        <ul class="md:grid md:grid-cols-4">
          <li v-for="section in sections" :key="section.title">
            <h2 class="dolphin-bold my-2">
              <AppLink
                tabindex="0"
                type="button"
                :to="section.path"
                v-if="section.path"
              >
                <span v-html="section.title" />
              </AppLink>
              <span v-else>{{ section.title }}</span>
            </h2>
            <template v-if="section && section.links">
              <PagesSitemapSection class="mb-8 mt-2" :links="section.links" />
            </template>
          </li>
        </ul>
      </div>
    </div>
    <CartUtilsLogin showLoginButton />
  </div>
</template>
